//mutations
export const APP_UPDATE = "appUpdate";

const state = {
  level: 0
};

const getters = {
  appUpdateLevel: ({level}) => level
};

const mutations = {
  [APP_UPDATE](state, level) {
    state.level = level;
  },
};

export default {
  state,
  mutations,
  getters
};
